export const url = process.env.REACT_APP_API_URL;

export function connect(endpoint){
    return fetch(url + endpoint)
}

export function connetParams(endpoint, params){
    return fetch(url + endpoint, params);
}

export function deleted(endpoint, params){
    return fetch(url + endpoint, params);
}

export function createAsistant(payload){
    return fetch(url + 'post_assistant', {  // Make sure the URL endpoint is correct for assistant
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
} 